interface TooltipProps {
    content: string
    placement?: 'top' | 'right' | 'bottom' | 'left'
    className?: string
    children: React.ReactNode
}

export const Tooltip = ({
    content,
    placement = 'bottom',
    className = '',
    children,
}: TooltipProps) => {
    return (
        <div className={`group ${className}`}>
            {children}
            <div
                className={`text-sm absolute z-auto rounded-md bg-gray-900 px-3 py-2 font-medium text-white opacity-0 shadow-sm transition-opacity duration-300 group-hover:opacity-100 ${placement === 'top' ? 'bottom-full left-1/2 mb-2 -translate-x-1/2' : ''} ${placement === 'right' ? 'left-full top-1/2 ml-2 -translate-y-1/2' : ''} ${placement === 'bottom' ? 'left-1/2 top-full mt-2 -translate-x-1/2' : ''} ${placement === 'left' ? 'right-full top-1/2 mr-2 -translate-y-1/2' : ''} whitespace-nowrap`}
            >
                {content}
                <div
                    className={`absolute h-2 w-2 -translate-x-1/2 rotate-45 transform bg-gray-900 ${placement === 'top' ? 'bottom-0 left-1/2 translate-y-1' : ''} ${placement === 'right' ? 'left-0 top-1/2 -translate-x-1 -translate-y-1/2' : ''} ${placement === 'bottom' ? 'left-1/2 top-0 -translate-y-1' : ''} ${placement === 'left' ? 'right-0 top-1/2 -translate-y-1/2 translate-x-1' : ''} `}
                ></div>
            </div>
        </div>
    )
}
